<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import { RouterLink } from 'vue-router'

import AppIcon from '@/components/common/AppIcon.vue'

const { t } = useI18n()
</script>

<template>
  <section class="mx-auto max-w-lg py-12 text-center">
    <p class="font-display text-primary-300 text-6xl font-bold sm:text-7xl">
      {{ t('notFound.code') }}
    </p>
    <AppIcon name="mdi-map-marker-question-outline" class="text-gold-600 mt-2 text-4xl" />

    <h1 class="font-display text-abyss-900 mt-3 text-2xl font-bold">{{ t('notFound.title') }}</h1>
    <p class="text-abyss-800/70 mt-2 text-sm">{{ t('notFound.body') }}</p>

    <RouterLink :to="{ name: 'home' }" class="btn-primary mt-6 inline-flex">
      {{ t('common.backToHome') }}
    </RouterLink>
  </section>
</template>
